const defaultError = () => console.error('sessionStorage error');
export const get = (key, errorCallback = defaultError) => {
  let item;
  try {
    item = sessionStorage.getItem(key);
  } catch (error) {
    errorCallback(error);
  }
  return item;
};